export default {
  init($element) {
  },
  finalize($element) {
    // Set element height based on viewport height
    $element.css({ 'height': $(window).innerHeight() + 'px' });

    $('window').on('resize', function() {
      $element.css({ 'height': $(window).innerHeight() + 'px' });
    });

    /**
     * Close filter dialogue
     */
    $element.find('.btn-filter-close').on('click', function() {
      $element.removeClass('open');
      $('body').removeClass('overflow-hidden');
    });

    $element.on('click', function(e) {
      if (e.target == $element.get()[0]) {
        $element.removeClass('open');
      }
    });

    /**
     * Select a filter
     */
    $element.find('.filter-body button').on('click', function() {
      const value = $(this).data('value');
      const type = $(this).data('type');
      let name = $(this).data('name');

      if (type == 'chip' || type == 'check' || type == 'slider') {
        // Multi-select
        name += '[]';
      } else {
        // Single select, de-select all others of this type
        $(this).siblings().removeClass('selected');
      }

      const $inputElement = $element.find('#walk-listing-filter-form').find(`input[name="${name}"][value="${value}"]`);
      $inputElement.prop('checked', !$inputElement.prop('checked'));

      if ($inputElement.prop('checked')) {
        $(this).addClass('selected');
      } else {
        $(this).removeClass('selected');
      }
    });

    /**
     * Show all 
     */
    $element.find('.show-more-btn').on('click', function() {
      if ($(this).hasClass('showing')) {
        $(this).removeClass('showing');
        $(this).find('.label-hide').addClass('d-none');
        $(this).find('.label-show').removeClass('d-none');
      } else {
        $(this).addClass('showing');
        $(this).find('.label-hide').removeClass('d-none');
        $(this).find('.label-show').addClass('d-none');
      }

      $(this).siblings('.of-item').each(function(i) {
        let speed = (200 + (i * 50));

        if ($(this).is(':visible')) {
          speed = (200 - (i * 50));
        }

        $(this).stop().fadeToggle(speed);
      });
    });

    /**
     * Reset filter button
     */
    $element.find('.btn-filter-reset').on('click', function() {

      // Reset the DOM form
      $element.find('#walk-listing-filter-form').trigger('reset');

      // Fallback to reset the form
      $element.find('#walk-listing-filter-form input').prop('checked', false);

      // Add 'reset' input to allow scrolling down to content after reset.
      $('<input hidden name="reset" value="true" type="text" />').appendTo($element.find('#walk-listing-filter-form'));

      // Reset the mask form
      $element.find('.filter-body button').each(function() {
        $(this).removeClass('selected');
      });
    });

    /**
     * Auto-scroll to main content if filters are added
     */
    if ($('a[name="skip-content"]').length > 0) {
      window.scrollTo(0, $('a[name="skip-content"]').offset().top);
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/walk-listing/walkListingFilter.js